function randomDeviceCode() {
    const suffix = crypto.randomUUID().replace(/-/g, '').slice(0, 8).toUpperCase();
    return `GS-${suffix}`;
}
/** In-memory credentials — tests and non-persistent shells. */
export class MemoryCredentialStore {
    credential = null;
    deviceCode = null;
    async get() {
        return this.credential;
    }
    async set(credential) {
        this.credential = credential;
    }
    async clear() {
        this.credential = null;
    }
    async getOrCreateDeviceCode() {
        if (!this.deviceCode)
            this.deviceCode = randomDeviceCode();
        return this.deviceCode;
    }
}
//# sourceMappingURL=memory-credential-store.js.map